import React, { useEffect, useState } from "react";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaHome, FaUserPlus, FaSignInAlt } from "react-icons/fa";
import "./header.css";

import { setDataLayout } from "../../core/data/redux/themeSettingSlice";

import ImageWithBasePath from "../../core/common/imageWithBasePath";

import {
  setMobileSidebar,
  toggleMiniSidebar,
} from "../../core/data/redux/sidebarSlice";

import { all_routes } from "../router/all_routes";
import CommonSelect, {
  Option,
} from "../pages/license-registration-form/CommonSelect";
// import { HorizontalSidebarData } from "../../core/data/json/horizontalSidebar";
import { label } from "yet-another-react-lightbox/*";
import { setHomeLanguage } from "../../core/data/redux/authSlice";
import { getSSODetails, getSsoToken } from "../auth/services/privateapicalling";

const HomeHeader = () => {
  const routes = all_routes;
  const [searchParams] = useSearchParams();
  const selectedRole = searchParams.get("role");
  const dispatch = useDispatch();
  // const dataLayout = useSelector((state: any) => state.themeSetting.dataLayout);
  const Location = useLocation();
  const navigate = useNavigate();
const hlanguage = useSelector((state:any)=>state.auth.homeLanguage,
);
  const [subOpen, setSubopen] = useState<any>("");
  const [subsidebar, setSubsidebar] = useState("");
  const [isRoleSelected, setIsRoleSelected] = useState(false);

  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);

  const ssoid = queryParams.get('SSOId');
  // const ssoid = "NxAyMTA2MjgxNjNzNDcwMDAwMDA%3D";
    const loginRole = queryParams.get("role");



  
 const setlang = hlanguage.home === "Home" ? "english" : "gujarati";

  const [selectedLanguage, setSelectedLanguage] = useState<{
    label: string;
    value: string;
  }>({
    label: setlang === "english" ? "English" : "ગુજરાતી",
    value: setlang,
  });
  
  const handleLanguageChange = (option: Option | null) => {
    if (option) {
      setSelectedLanguage(option);
      dispatch(setHomeLanguage(option.value));
      //.log(option.value);
    }
  };




  useEffect(() => {
    if (selectedRole) {
      setIsRoleSelected(true);
    }
  }, [selectedRole]);

  const toggleSidebar = (title: any) => {
    localStorage.setItem("menuOpened", title);
    if (title === subOpen) {
      setSubopen("");
    } else {
      setSubopen(title);
    }
  };

  const toggleSubsidebar = (subitem: any) => {
    if (subitem === subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };

  const [isFullscreen, setIsFullscreen] = useState(false);
  const toggleFullscreen = () => {
    if (!isFullscreen) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen().catch((err) => {});
        setIsFullscreen(true);
      }
    } else {
      if (document.exitFullscreen) {
        if (document.fullscreenElement) {
          document.exitFullscreen().catch((err) => {});
        }
        setIsFullscreen(false);
      }
    }
  };

   const handleSSOLogin = (role)=>{
    const returnurl = `https://uat-eapmc.thesaicomputers.com/ssoLogin/${role}`;
    const accesskey = "b6e01c1d689344ad9b412200fb365cc3";

    const combined = `${returnurl}||${accesskey}`;
    const base64Encoded =  btoa(combined)
   
    window.location.href = `https://gujaratsso.gujarat.gov.in/?redirectUrl=${base64Encoded}`;
  }

   const handleSSOSignUp = ()=>{
    const returnurl = "https://uat-eapmc.thesaicomputers.com/";
    const accesskey = "b6e01c1d689344ad9b412200fb365cc3";

    const combined = `${returnurl}||${accesskey}`;
    const base64Encoded =  btoa(combined)
    
    window.location.href = `https://gujaratsso.gujarat.gov.in/CitizenSSORegistration/UserForm?redirectUrl=${base64Encoded}`;
  }

  return (
    <>
      <div className="header-home " style={{
    backgroundImage: "linear-gradient(to right,#275237 ,#FFE000 )", 
   
  }}>
        <div className="main-header">
          <div className="header-left"></div>

          <div className="header-user">
            <div className="nav user-menu nav-list">
              <div className="align-items-center justify-content-center ">
                <div className="text-white  align-items-center fs-17 fw-bold">
                  <ImageWithBasePath src="assets/img/GAPMC.png" alt="Logo"  style={{height:"50px",width:"50px"}}/> 
                  &nbsp;
                  {hlanguage.g2}
                </div>
              </div>
              {/* <ImageWithBasePath src="assets/img/gil.png" alt="Logo" /> */}
              <div className="d-flex align-items-center  "></div>

              <div
                className="me-auto d-flex align-items-center"
                id="header-search"
              ></div>

              <div
                className="sidebar sidebar-horizontal"
                id="horizontal-single"
              >
                <div className="sidebar-menu">
                  <div className="main-menu"></div>
                </div>
              </div>
             
               <div className="d-flex align-items-center justify-content-center me-5 ">
                <h5 className="text-white me-2"> {hlanguage.lang}:</h5>
                <CommonSelect
                    options={[
                      { label: "English", value: "english" },
                      { label: "ગુજરાતી", value: "gujarati" },
                    ]}
                    value={selectedLanguage} 
                    defaultValue={selectedLanguage}
                    onChange={(option) => {
                      if (option) {
                        setSelectedLanguage(option);
                        dispatch(setHomeLanguage(option.value));
                      }
                    }}
                  />
              </div>


              <div className="d-flex align-items-center">
                <div className="profile-dropdown mx-2">
                  <div className="btn-group">
                  
                    <button
                      type="button"
                      className="btn btn-success dropdown-toggle rounded-pill"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      style={{
                        background: "inherit", 
                        color: "white",
                        border: "none",
                        padding: "10px 20px",
                      }}
                    >
                      <i className="fas fa-user mx-1"></i>
                      {hlanguage.login}
                    </button>
                    <ul className="dropdown-menu">
                      {[
                        { value: "Trader_Login", label: hlanguage.tra_login },
                        { value: "GCA_Login", label:hlanguage.gc_login },
                         { value: "Sponsor_Login", label: hlanguage.spon_login},
                        {
                          value: "Panel_Engineer_Login",
                          label: hlanguage.pa_login,
                        },
                        {
                          value: "District_Registrar_Login",
                          label: hlanguage.dr_login
                        },
                        { value: "APMC_Login", label: hlanguage.ap_login },
                        {
                          value: "Head_officer_Login",
                          label: hlanguage.ho_login
                        },
                      ].map((item) => (
                           <li key={item.label}>
                            {["Trader_Login", "Panel_Engineer_Login"].includes(item.value) ? (
                              <button
                                type="button"
                                className="dropdown-item "
                                 onClick={() => {
                                  const loginRole =
                                    item.value === "Trader_Login"
                                      ? "Trader"
                                      : item.value === "Panel_Engineer_Login"
                                      ? "Panel_Engineer"
                                      : "";
                                  handleSSOLogin(loginRole);
                                }}
                                style={{
                                  background: "inherit",
                                  // color: "white",
                                  border: "none",
                                  // padding: "10px 20px",
                                }}
                              >
                                <i className="fas fa-sign-in-alt mx-1"></i> 
                                {item.label}
                              </button>
                            ) : (
                              <Link
                                className="dropdown-item"
                                to={`${all_routes.login2}?role=${item.value}`}
                              >
                                <i className="fas fa-sign-in-alt mx-1"></i> {item.label}
                              </Link>
                            )}
                            </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="profile-dropdown mx-2">
                  <div className="btn-group">
                    <button
                      type="button"
                      className="btn btn-success dropdown-toggle rounded-pill"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      style={{
                        background: "inherit", 
                        color: "white",
                        border: "none",
                        padding: "10px 20px",
                      }}
                    >
                      <i className="fa fa-home mx-1"></i>
                    </button>
                    <ul className="dropdown-menu">
                      <li>
                        <Link className="dropdown-item" to="/">
                          <i className="fa fa-home mx-1"></i>
                          {hlanguage.home}
                        </Link>
                      </li>
                    </ul>
                  </div>
                  {/* </span> */}
                </div>
                <div className="me-1">
                  <Link
                    to="#"
                    onClick={toggleFullscreen}
                    className="btn btn-menubar btnFullscreen"
                  >
                    <i
                      className="ti ti-maximize"
                      style={{ color: "white" }}
                    ></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="dropdown mobile-user-menu">
            <Link
              to="#"
              className="nav-link dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            

            >
              <i className="fa fa-ellipsis-v"></i>
            </Link>
            <div className="dropdown-menu dropdown-menu-end">
              
            <ul className="dropdown-item">
                      {[
                        { value: "Trader_Login", label: hlanguage.tra_login },
                        { value: "GCA_Login", label: "GCA Login" },
                        { value: "Sponsor_Login", label: "Sponsor Login" },
                        {
                          value: "Panel_Engineer_Login",
                          label: hlanguage.pa_login,
                        },
                        {
                          value: "District_Registrar_Login",
                          label: hlanguage.dr_login,
                        },
                        { value: "APMC_Login", label: hlanguage.ap_login },
                        {
                          value: "Head_officer_Login",
                          label: hlanguage.ho_login,
                        },
                      ].map((item) => (
                        <li key={item.label}>
                          <Link
                            className="dropdown-item"
                            to={`${all_routes.login2}?role=${item.value}`}
                          >
                            <i className="fas fa-sign-in-alt mx-1"></i>{" "}
                            {item.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                    <Link className="dropdown-item" to="/">
                          <i className="fa fa-home mx-1"></i>
                         {hlanguage.home}   
                        </Link>
                       

              {/* <Link className="dropdown-item" to={routes.profilesettings}>
                Settings
              </Link>
              <Link className="dropdown-item" to={routes.login}>
                Logout
              </Link> */}
            </div>
          </div>
        </div>
      </div>
      {/* /Header */}
    </>
  );
};

export default HomeHeader;
